import Flickity from 'flickity';
import Masonry from 'masonry-layout';

// first carousel
const flickityElement = document.querySelector(".index-carousel");
if(flickityElement) {
    const flickity = new Flickity(flickityElement, {
        arrowShape:         '',
        cellAlign:          'right',
        groupCells:         true,
        pageDots:           true,
        freeScroll:         true,
        freeScrollFriction: 0.03
    });

    const flickityHandleMouseWheel = (e, flickityInstance, flicktiyIsAnimating) => {
        // do not trigger a slide change if another is being animated
        if(!flicktiyIsAnimating) {
            // pick the larger of the two delta magnitudes (x or y) to determine nav direction
            const direction = (Math.abs(e.deltaX) > Math.abs(e.deltaY)) ? e.deltaX : e.deltaY;

            console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

            if(direction > 0) {
                // next slide
                flickityInstance.next();
            } else {
                // prev slide
                flickityInstance.previous();
            }
        }
    }

    let flickityIsAnimating = false;
    flickity.on("settle", function(index) {
        flickityIsAnimating = false;
    });

    flickity.on("select", function(index) {
        flickityIsAnimating = true;
    });

    // detect mousewheel event within carousel element
    flickityElement.onwheel = function(e) {
        flickityHandleMouseWheel(e, flickity, flickityIsAnimating);
    }
}

if(document.querySelector('.museum-details')) {
    const masonry = new Masonry('.museum-details', {
        itemSelector:    '.detail',
        columnWidth:     '.detail',
        percentPosition: true
    });
}

// WOW animated
const wow = new WOW({
    boxClass:     'wow', // default
    animateClass: 'animated', // default
    offset:       0, // default
    mobile:       true, // default
    live:         true // default
});
wow.init();

// BenedenBoven cookiescript
new CookieNotification();

if(document.querySelector('.bg-primary.overflow-visible')) {
    const elementHeight = document.querySelector('.bg-primary.overflow-visible').offsetHeight;

    window.addEventListener('scroll', () => {
        if(window.scrollY > elementHeight) {
            document.querySelector('.logo').style.mixBlendMode = 'difference';
        } else {
            document.querySelector('.logo').style.mixBlendMode = 'normal';
        }
    })
}

if(document.querySelector('.mouse')) {
    document.querySelector('.mouse').addEventListener('click', () => {
        window.scroll({
            top:      document.querySelector('.mouse').nextElementSibling.offsetTop,
            behavior: 'smooth'
        });
    });
}

// Pop-ups
if(document.querySelector('#pop-up-modal')) {
    $('#pop-up-modal').modal('show');

    $('#pop-up-modal').on('hidden.bs.modal', function(e) {
        fetch('/api/popup/close/' + document.getElementById('pop-up-modal').dataset.hash);
    })
}

if(document.querySelector('.main-content')) {
    document.querySelectorAll('.main-content').forEach(item => {
        item.querySelectorAll('img').forEach(image => {
            image.classList.add('img-fluid');
        });

        item.querySelectorAll('table').forEach(table => {
            table.classList.add('table', 'table-striped', 'table-hover');
            table.border = 0;

            if(!table.parentNode.classList.contains('table-responsive')) {
                let wrapper       = document.createElement('div');
                wrapper.className = 'table-responsive';

                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });

        item.querySelectorAll('iframe').forEach(iframe => {
            iframe.classList.add('embed-responsive-item');
            iframe.border = 0;

            if(iframe.src.match(/youtube|youtu/)) {
                if(!iframe.parentNode.classList.contains('embed-responsive-16by9')) {
                    let wrapper       = document.createElement('div');
                    wrapper.className = 'embed-responsive embed-responsive-16by9';

                    iframe.parentNode.insertBefore(wrapper, iframe);
                    wrapper.appendChild(iframe);
                }
            } else {
                if(!iframe.parentNode.classList.contains('embed-responsive')) {
                    let wrapper       = document.createElement('div');
                    wrapper.className = 'embed-responsive';

                    iframe.parentNode.insertBefore(wrapper, iframe);
                    wrapper.appendChild(iframe);
                }
            }
        });
    });
}


(function($) {
    "use strict"; // Start of use strict

    // Append .background-image-holder <img>'s as CSS backgrounds
    $('.background-image-holder').each(function() {
        var imgSrc = $(this).children('img').attr('src');
        $(this).css('background', 'url("' + imgSrc + '")');
        $(this).children('img').hide();
        $(this).css('background-position', 'initial');
    });

    // MAP
    $('.map-holder').click(function() {
        $(this).addClass('interact');
    });

    if($('.map-holder').length) {
        $(window).scroll(function() {
            if($('.map-holder.interact').length) {
                $('.map-holder.interact').removeClass('interact');
            }
        });
    }

    // Gridzy
    $('.gridzy').gridzy({
        spaceBetween:  12,
        desiredHeight: 250
    });

    // Modulobox
    var modulobox = new ModuloBox({
        mediaSelector:      '.gallery figure > a, .hidden-gallery div',
        loop:               3,
        history:            true,
        controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
        shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
        videoMaxWidth:      1440,
        minZoom:            1,
        zoomTo:             1.8,
        mouseWheel:         false,
        contextMenu:        false,
        scrollToZoom:       true,
        captionSmallDevice: false,
        thumbnails:         true,
        thumbnailsNav:      'centered',
        thumbnailSizes:     {
            1920: {
                width:  110,
                height: 80,
                gutter: 10
            },
            1280: {
                width:  90,
                height: 65,
                gutter: 10
            },
            680:  {
                width:  0,
                height: 0,
                gutter: 0
            }
        }
    });

    modulobox.on('beforeOpen.modulobox', function(gallery, index) {

        if(window.cubeRAF) {

            cancelAnimationFrame(window.cubeRAF);
            window.cubeRAF = false;

        }

    });

    modulobox.on('afterClose.modulobox', function(gallery, index) {

        if(typeof Event === 'function' && !window.cubeRAF) {
            window.dispatchEvent(new Event('scroll'));
        }

    });

    modulobox.init();

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
        if(location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target     = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if(target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 150
                }, 1000, "easeInOutExpo");
                return false;
            }
        }
    });

    // Parallax header
    $(function() {
        // 	init scrollmagic
        var controller = new ScrollMagic.Controller();

        //  HEADER BACKGROUND IMAGE SCROLL
        $(".page-title").each(function() {

            var bg = $(this).find(".background-image");

            // Add tweenmax for backgroundParallax
            var parallax = TweenMax.from(bg, 1, {
                y:    '-20%',
                ease: Power0.easeNone
            });

            // Create scrollmagic scene
            var parallaxScene = new ScrollMagic.Scene({
                triggerElement: this, // <-- Use this to select current element
                triggerHook:    1,
                duration:       '200%',
            })
                .setTween(parallax)
                .addTo(controller);
        });
    });

})(jQuery); // End of use strict

//3D EFFECT
$(document).mousemove(function(event) {
    $(".dots-move-1").each(function(index, element) {
        var xPos = (event.clientX / $(window).width()) - 1.1,
            yPos = (event.clientY / $(window).height()) - 1.1,
            box  = element;
        TweenLite.to(box, 1, {
            rotationY: xPos * 20,
            rotationX: yPos * 20,
            ease:      Power1.easeOut,
        });
    });
    $(".dots-move-2").each(function(index, element) {
        var xPos = (event.clientX / $(window).width()) - 1,
            yPos = (event.clientY / $(window).height()) - 1,
            box  = element;
        TweenLite.to(box, 1, {
            rotationY: xPos * 20,
            rotationX: yPos * 20,
            ease:      Power1.easeOut,
        });
    });
    $(".dots-move-3").each(function(index, element) {
        var xPos = (event.clientX / $(window).width()) - 0.2,
            yPos = (event.clientY / $(window).height()) - 0.2,
            box  = element;
        TweenLite.to(box, 1, {
            rotationY: xPos * 20,
            rotationX: yPos * 20,
            ease:      Power1.easeOut,
        });
    })
});
